import { Component, OnInit, ChangeDetectionStrategy, Input, Output } from '@angular/core';
import { IBoaActivity, AgendapuntService, IBoaAttachment } from 'src/app/agendapunt/agendapunt.service';
import { Observable, ReplaySubject } from 'rxjs';
import { createCmdFactory } from '@cevi/rxjscommands';
import { map, switchMap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { AppRoutingService } from 'src/app/shared/app-routing.service';
import { MenuService } from 'src/app/shared/menu.service';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

interface ivm {
  activity: IBoaActivity;
}

@Component({
    selector: 'app-boa-activity',
    templateUrl: './boa-activity.component.html',
    styleUrls: ['./boa-activity.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, NgFor, AsyncPipe]
})
export class BoaActivityComponent implements OnInit {

  public vm$: Observable<ivm>;

  constructor(
    private route: ActivatedRoute,
    private agendapuntService: AgendapuntService,
    private routingService: AppRoutingService,
    private menuService: MenuService
  ) {
    this.routingService.createCurrentHistoryItem('Wijzig notitie');
    const cmdFactory = createCmdFactory<ivm>();
    cmdFactory.addMapAction(this.activityFromRouteAction$, 'activityAction$');
    this.vm$ = cmdFactory.merge({} as ivm);
  }
  private activityFromRouteAction$ = this.route.paramMap.pipe(
    switchMap(paramMap => this.agendapuntService.getBoaDetail(paramMap.get('id'))),
    map(activity => (vm: ivm) => ({ ...vm, activity }))
  );


  public cancel() {
    this.routingService.navigateBack();
  }
  public openDocument = (attachment: IBoaAttachment) => {
    this.menuService.openBoaDocument(attachment.DocRef, attachment.Name, attachment.Extensie);
  }

  ngOnInit() {
  }

}
